export default "__VITE_ASSET__851d6ea5__"